import { useEffect, useState } from 'react'
import { RequestStatus } from '@sales-center/common'
import { fetchAllActivityHistoryFilters } from '../effects/fetchAllActivityHistoryFilters.effect'
import { useActivitiesContext } from '../context'

export function useFetchAllActivityHistoryFilters() {
  const [, dispatch] = useActivitiesContext()
  const [status, setStatus] = useState<RequestStatus>('idle')

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      setStatus('loading')

      const action = await fetchAllActivityHistoryFilters()

      if (mounted) {
        dispatch(action)
        setStatus('idle')
      }
    }

    execute()

    return () => {
      mounted = false
    }
  }, [dispatch])

  return status
}
